<template>
  <div>
    <div class="full-screen" v-loading="true" v-if="accessPermitted"></div>
    <div v-else class="container text-center">
      <div class="row">
        <div class="col-lg-8 col-xl-6 col-sm-11 col-md-11 mx-auto">
          <h1 class="display-3 my-4">
            {{ $t('mayday-web.content-not-available.title') }}
          </h1>
          <p>{{ $t('mayday-web.content-not-available.sub-title') }}</p>

          <img id="gif" src="@/assets/access_not_permited.gif" />

          <router-link class="mt-3 d-block" to="/web">
            <base-button type="primary" class="my-2">{{
              $t('mayday-web.content-not-available.back-to-home')
            }}</base-button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      accessPermitted: true,
      contentAvailable: false,
    };
  },
  methods: {
    ...mapActions('webKnowledgeModule', ['goToContent', 'goToCase']),
  },
  async mounted() {
    const { contentId, stepId, caseId } = this.$route.params;
    const { hash } = this.$route;

    this.accessPermitted = caseId
      ? await this.goToCase({ caseId })
      : await this.goToContent({ contentId, stepId, hash });
  },
};
</script>

<style scoped>
#gif {
  max-width: 50vh;
  border-radius: 5px;
}
.full-screen {
  height: 100vh;
  width: 100%;
}
</style>
